// extracted by mini-css-extract-plugin
module.exports =  {"bar":"Ymmvwmg4FVxuxMT75oP0"};